import { FaExclamationCircle, FaRegTrashAlt } from "react-icons/fa";
import Loader from "../../../../../../Atoms/Loader";

export default function DeleteWorkspaceModal({ isOpen, onClose, onConfirm, isLoading }) {
    if (!isOpen) return null;

    return (
        <div className="modal-overlay" id="delete-workspace-modal">
            <div className="modal-container">
                <button className="modal-close" onClick={() => onClose()}>×</button>

                <div className="modal-icon">
                    <FaExclamationCircle size={32} color="#FFD400" />
                </div>

                <h2 className="modal-title">Apagar trabalho?</h2>
                <p className="modal-description mb-3">
                    Deseja realmente apagar o trabalho?
                </p>

                {isLoading ? (
                    <div className="d-flex flex-row gap-2 align-items-center justify-content-center w-full">
                        <Loader/>
                        <span>Apagando workspace...</span>
                    </div>
                ) : (
                    <div className="modal-actions">   
                            <button 
                                className="btn-cancel"
                                onClick={() => {
                                    onClose()
                                }}
                            >
                                Cancelar
                            </button>

                            <button
                                className="btn-delete"
                                onClick={() => {
                                    onConfirm?.();
                                }}
                            >
                                <FaRegTrashAlt className="btn-delete-icon" />
                                Apagar
                            </button>
                        
                    </div>
                )}
            </div>
        </div>
    )
}
